<template>
  <div class="select-with-operation">
    <el-select v-model="selectValue" placeholder="请选择" size="mini" popper-class="select-with-operation-main" :popper-append-to-body="false" @change="changeSelectValue">
      <el-option v-for="item in optionList" :key="item.code" :label="item.name" :value="item.code">
        <span style="float: left;">{{ item.name }}</span>
        <span style="float: right; color: #8492a6; font-size: 13px">
<!--          <i class="el-icon-damai-ic_xiugai"></i>-->
          <i class="el-icon-damai-shanchu" @click.stop="deleteOption(item)"></i>
        </span>
      </el-option>
      <div class="add-line" @click.stop="addOption">
        <i class="el-icon-plus"></i><span>添加</span>
      </div>
    </el-select>
  </div>
</template>

<script>
import {nError} from "../../utils/notice";

export default {
  name: "SelectWithOperation",
  props: {
    selectValue: {
      type: String,
      default: ''
    },
    optionList: {
      type: Array,
      default: []
    },
    deleteTipInfo: {
      type: String,
      default: '是否确认删除该选项？'
    },
    addTip: {
      type: String,
      default: '添加'
    }
  },
  data () {
    return {}
  },
  methods: {
    changeSelectValue (e) {
      this.$emit('changeSelectValue', e)
    },
    deleteOption (option) {
      this.$confirm(this.deleteTipInfo, "温馨提示", {
        type: "warning"
      })
        .then(() => {
          this.$emit('deleteOption', option)
        })
        .catch(() => {
          console.log("取消删除");
        });

    },
    addOption () {
      this.$emit('addOption')
    }
  }
}
</script>

<style lang="less" scoped>
.select-with-operation {
  display: flex;

}

/deep/ .select-with-operation-main {
  .el-scrollbar {
    display: block!important;
  }
  .el-select-dropdown__empty {
    display: none!important;
  }
  .el-select-dropdown__list {
    .el-icon-damai-ic_xiugai {
      color: #999999;
      font-size: 12px;
    }
    .el-icon-damai-shanchu {
      color: #999999;
      font-size: 12px;
    }
    .add-line {
      height: 30px;
      line-height: 30px;
      padding: 0 10px;
      margin: 10px 20px 15px 20px;
      display: flex;
      justify-content: center;
      align-items: center;
      border: 1px solid #1362FF;
      border-radius: 10px;
      span, .el-icon-plus {
        margin: 0 2px;
        color: #1362FF;
      }
    }
    .add-line:hover {
      cursor: pointer;
      background-color: #1362FF;
      span, .el-icon-plus {
        color: #FFFFFF;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Select/SelectWithOperation.vue